import axios from 'axios';

export default {
  getStorageData(tenant) {
    console.log('Fetching storage data for tenant:', tenant);
    
    // Use Rails proxy route (works in both development and production)
    const url = `/api/v1/storage/${tenant}`;
    
    console.log('Storage API URL (via Rails proxy):', url);
    
    return axios.get(url, { 
      timeout: 10000, // 10 second timeout
      headers: {
        'Accept': 'application/json'
      }
    }).then(response => {
      console.log('Storage API response status:', response.status);
      console.log('Storage API response data:', response.data);
      
      // Check if we have the expected nested structure
      if (response.data && response.data.data && response.data.data.storage_details) {
        const storageDetails = response.data.data.storage_details;
        console.log('✅ Storage details found:', storageDetails);
        console.log('📊 Storage breakdown:');
        console.log('   Legal Cases:', storageDetails.legal_case_bytes);
        console.log('   Resources:', storageDetails.resource_bytes);
        console.log('   Radiology:', storageDetails.radiology_bytes || 0);
        console.log('   Total:', storageDetails.total_bytes);
        
        // Extract the storage_details for easier access in components
        return {
          ...response,
          data: {
            storage_details: storageDetails,
            tenant: response.data.tenant
          }
        };
      } else {
        console.error('❌ Unexpected response structure:', response.data);
        throw new Error('Invalid response structure from storage API');
      }
    }).catch(error => {
      console.error('Error fetching storage data:', error);
      console.error('Error details:', {
        message: error.message,
        code: error.code,
        status: error.response?.status,
        statusText: error.response?.statusText,
        responseData: error.response?.data,
        url: url
      });
      throw error;
    });
  }
};
